import api from '@shared/services/api';

/** Supported `/emp` search query keys. */
export const REGISTER_SEARCH_KEYS = [
    'name',
    'fathersName',
    'surname',
    'idn',
    'empId',
    'orgUnitId',
];

export function normalizeRegisterSearchQuery(searchQuery) {
    if (!searchQuery || typeof searchQuery !== 'object') {
        return searchQuery;
    }

    const next = {};
    REGISTER_SEARCH_KEYS.forEach((key) => {
        const value = searchQuery[key];
        if (value != null && String(value).trim() !== '') {
            next[key] = String(value).trim();
        }
    });
    return next;
}

export const registerService = {
    getRegister: async (params = {}) => {
        const queryParams = new URLSearchParams();
        if (params.page !== undefined) queryParams.append('page', params.page);
        if (params.pageSize !== undefined) queryParams.append('pageSize', params.pageSize);
        if (params.sortBy) queryParams.append('sortBy', params.sortBy);
        if (params.sortDir) queryParams.append('sortDir', params.sortDir);
        if (params.additionalContract !== undefined && params.additionalContract !== null && params.additionalContract !== '') {
            queryParams.append(
                'additionalContract',
                String(params.additionalContract === true || params.additionalContract === 'true')
            );
        }
        if (params.terminated !== undefined && params.terminated !== null && params.terminated !== '') {
            queryParams.append(
                'terminated',
                String(params.terminated === true || params.terminated === 'true')
            );
        }
        const searchQuery = normalizeRegisterSearchQuery(params.searchQuery);
        if (searchQuery && typeof searchQuery === 'object') {
            Object.entries(searchQuery).forEach(([key, value]) => {
                if (value) queryParams.append(key, value);
            });
        }
        const queryString = queryParams.toString();
        const url = `/emp${queryString ? `?${queryString}` : ''}`;
        const response = await api.get(url);
        try {
            return response.data;
        } catch (error) {
            console.error('Error fetching register:', error);
            throw error;
        }
    },
    getEmpFile: async (id) => {
        const response = await api.get(`/emp/file/${id}`);
        return response.data;
    },
    deleteEmp: async (id) => {
        const response = await api.delete(`/emp/${id}`);
        return response.data;
    },
    createRegister: async (data, queryParams = {}) => {
        const params = new URLSearchParams();
        if (queryParams.createAnother) {
            params.append('createAnother', queryParams.createAnother);
        }
        const queryString = params.toString();
        const url = `/emp${queryString ? `?${queryString}` : ''}`;
        const response = await api.post(url, data);
        return response.data;
    },
    getCurrentStatus: async (empId) => {
        const response = await api.get(`/emp-contracts/current-status/${empId}`);
        return response.data;
    },
    getNoiNotifies: async (params = {}) => {
        const queryParams = new URLSearchParams();
        if (params.page !== undefined) queryParams.append('page', params.page);
        if (params.size !== undefined) queryParams.append('size', params.size);
        if (params.sortBy) queryParams.append('sortBy', params.sortBy);
        if (params.sortOrder) queryParams.append('sortOrder', params.sortOrder);
        if (params.old === true) queryParams.append('old', 'true');
        if (params.fromDate) queryParams.append('fromDate', params.fromDate);
        if (params.toDate) queryParams.append('toDate', params.toDate);
        if (params.status !== undefined && params.status !== null && params.status !== '') queryParams.append('status', String(params.status));
        const queryString = queryParams.toString();
        const url = `/noi-notifies${queryString ? `?${queryString}` : ''}`;
        const response = await api.get(url);
        return response.data;
    },
    postNoiNotify: async (queryParams = {}) => {
        const response = await api.post('/noi-notifies', {}, {
            params: {
                excludedType: Boolean(queryParams.excludedType),
            },
        });
        return response.data;
    },
    patchNoiNotify: async (parId) => {
        const response = await api.patch(`/noi-notifies/${parId}`);
        return response.data;
    },
    patchNoiNotifyConfirm: async (parId) => {
        const response = await api.patch(`/noi-notifies/confirm/${parId}`);
        return response.data;
    },
    postNoiNotifyExportNra: async (parId) => {
        const response = await api.post(`/noi-notifies/export-nra/${parId}`, {});
        return response.data;
    },
    getEmpContractsParId: async (parId) => {
        const response = await api.get(`/emp-contracts/par-id/${parId}`);
        return response.data;
    },
    getEmpContractsReport: async (id) => {
        const response = await api.get(`/emp-contracts/report/${id}`);
        return response.data;
    },
    searchPersons: async (searchParams = {}) => {
        try {
            const params = new URLSearchParams();

            if (searchParams.idn) {
                params.append('idn', searchParams.idn.trim());
            }
            if (searchParams.name) {
                params.append('name', searchParams.name.trim());
            }
            if (searchParams.fathersName) {
                params.append('fathersName', searchParams.fathersName.trim());
            }
            if (searchParams.surname) {
                params.append('surname', searchParams.surname.trim());
            }

            const queryString = params.toString();
            const url = `/persons${queryString ? `?${queryString}` : ''}`;
            const response = await api.get(url);
            return response.data;
        } catch (error) {
            console.error('Error searching persons:', error);
            throw error;
        }
    }
}